import { ChangeDetectionStrategy, Component, type TemplateRef, viewChild } from '@angular/core';

@Component({
    styleUrls: ['./ui-form-hint.scss'],
    selector: 'ui-form-hint',
    templateUrl: 'ui-form-hint.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiFormHintComponent {
    template = viewChild<TemplateRef<any>>('template');
}
